import { Box, Divider, Skeleton, Stack, Typography } from '@mui/material';
import type { FC } from 'react';
import { PAGE_CONTENT_MAX_WIDTH_LG } from '~/constants';
import type { OrdersBannerProps } from './OrdersBanner.types';

export const OrdersBanner: FC<OrdersBannerProps> = ({ imageUrl, count, isLoading, title, subtitle }) => {
  return (
    <Box component="section" bgcolor="#F9FAFB">
      <Box maxWidth={PAGE_CONTENT_MAX_WIDTH_LG} mx="auto" px={{ xs: 3, lg: 6 }}>
        <Stack direction="row" gap={{ xs: 3 }}>
          <Box
            component="img"
            src={imageUrl}
            alt={title}
            width={{ xs: 95, md: 178 }}
            sx={{ transform: { md: 'translateY(6px)' }, alignSelf: { xs: 'center', md: 'flex-end' } }}
          />

          <Stack direction="row" alignItems="center" gap={{ xs: 2, md: 3 }} pt={{ xs: 4 }} pb={{ xs: 3.25 }}>
            <Typography component="p" typography={{ xs: 'h3', md: 'h1' }}>
              {isLoading ? <Skeleton sx={{ color: 'transparent' }}>{count}</Skeleton> : count}
            </Typography>

            <Divider orientation="vertical" flexItem sx={{ borderWidth: 2, borderColor: 'primary.main' }} />

            <Stack>
              <Typography component="h1" typography={{ xs: 'h5', md: 'h3' }} fontWeight={700}>
                {title}
              </Typography>

              <Typography component="p" typography={{ xs: 'caption', md: 'body1' }}>
                {subtitle}
              </Typography>
            </Stack>
          </Stack>
        </Stack>
      </Box>
    </Box>
  );
};
